module.exports = __webpack_public_path__ + "media/images/lb/560-afb42b385d9bfb997bbb0b3e11f43d0a.svg";